import { TOfferCalculatorState } from '../types/redux';

export const selectBankOptions = (state: TOfferCalculatorState) => state.calculator.banksOptions;
